import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Grid,
    Modal,
    Paper,
    TextareaAutosize,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import theme from "../../styles/theme";
import _ from "lodash";
import useStyles from "../../styles/styles";
import useFormInputs from "../../hooks/useFormInputs";

const TrafficSourceIdListModal = ({data, modalData, closeModal, setTrafficSourceIdList}) => {
    const classes = useStyles();
    const [matches, setMatches] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [errors, setErrors] = useState([]);
    const [list, setList] = useState([]);
    const textAreaRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const onSubmit = () => {
        setSubmitLoading(true);
        setErrors([]);
        let newValue = list.split('\n');
        let inputError = false;

        newValue = newValue.map(item => item.toLowerCase());

        const {key, category} = inputs;
        const newData = {
            key,
            category,
        };
        if (duplicates.length) {
            newValue = _.uniqWith(newValue, _.isEqual);
        }

        Object.keys(newData).forEach(key => {
            const value = newData[key]
            if (value === '') {
                inputError = true;
            }
        });

        if (modalData.data.id) {
            newData.id = modalData.data.id;
        }
        if (!inputError) {
            const trafficSourceIdList = newValue.join(',')
            setTrafficSourceIdList(trafficSourceIdList)
            closeModal()
        } else {
            setSubmitLoading(false);
            setErrors(['error']);
        }
    };
    const {inputs, handleSubmit, setInputs} = useFormInputs(onSubmit);

    useEffect(() => {
        if (modalData) {
            if (modalData.value) {
                setList(modalData.value);
            }
            setInputs(inputs => ({
                ...inputs,
            }));
        }
    }, []);

    useEffect(() => {
        if (list.length) {
            triggerList();
            //Set Height Match Height
            // setHeight(textAreaRef.current.clientHeight);
        } else {
            setMatches([]);
        }
    }, [list]);

    const triggerList = () => {
        const arr = list.includes('\n') ? list.split('\n') : [list];
        const categoryName = modalData.category;
        let matchArr = [];
        matchArr = checkMatches('Traffic Source', data.allTrafficSource.nodes, arr);
        setMatches(matchArr);
    };

    /**
     * Checks for matches from what is entered in the list
     * @param type
     * @param nodes
     * @param arr
     * @returns {[]}
     */
    const checkMatches = (type, nodes, arr) => {
        let isMatch = [];
        let matchArr = [];
        arr.forEach((x) => {
            isMatch = nodes.filter(node => {
                const id = node.id.toLowerCase();
                return id === x.toLowerCase();
            });
            if (isMatch.length) {
                const match = isMatch[0];
                let isDuplicate = [];
                isDuplicate = matchArr.filter(item => item.id === match.id);

                matchArr.push({
                    type,
                    id: match.id,
                    error: false,
                    source: match,
                    isDuplicate: !!isDuplicate.length,
                    isDeleted: match.isDeleted || false
                });
            } else {
                matchArr.push({
                    type,
                    error: true,
                    source: x,
                    isDuplicate: false,
                    isDeleted: false
                });
            }
        });

        return matchArr;
    };

    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Please add your list
                        of Traffic Source Ids below.
                    </Typography>
                    {errors.includes('error') ? (
                        <Alert severity="error" style={{marginBottom: '10px'}}>Please add values to the highlighted
                            fields!</Alert>
                    ) : false}
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="body1">
                                <Box display="flex" flexDirection="row" alignItems="center">
                                    <strong>Traffic Source Ids</strong>
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <TextareaAutosize
                                ref={textAreaRef}
                                style={{width: '100%', height: '320px', overflow: 'scroll'}}
                                value={list}
                                onChange={(e) => {
                                    setList(e.target.value);
                                }}
                                defaultValue={modalData.value || ''}
                            />`
                        </Grid>
                        <Grid item xs={6}>
                            <Box style={{
                                padding: '1px 8px 0',
                                height: '300px',
                                overflowY: 'scroll',
                                overflowX: 'hidden'
                            }}>
                                {matches.length ? (
                                    <Grid container spacing={2}>
                                        <>
                                            {matches.map((matchItem, idx) => {
                                                const {error, source, isDeleted} = matchItem;
                                                return (
                                                    <Fragment key={idx.toString()}>
                                                        <Grid
                                                            item
                                                            xs={5}
                                                            style={{
                                                                marginBottom: '10px',
                                                                borderBottom: '1px solid #dbdbdb',
                                                                marginLeft: theme.spacing(1),
                                                                marginRight: theme.spacing(1),
                                                                padding: theme.spacing(1),
                                                            }}
                                                        >
                                                            {error || isDeleted ? (
                                                                <>
                                                                    {isDeleted ? (
                                                                        <Alert severity="error">
                                                                            This Traffic Source ID
                                                                            - <em>{list.id}</em> has been deleted!
                                                                        </Alert>
                                                                    ) : null}
                                                                    {error ? (
                                                                        <Typography color="error" variant="body2">
                                                                            <strong>
                                                                                Not a valid Traffic Source ID
                                                                                - <em>{source}</em>.
                                                                                please double check source!
                                                                            </strong>
                                                                        </Typography>
                                                                    ) : null}
                                                                </>
                                                            ) : (
                                                                <Typography variant="body2">
                                                                    <strong>Traffic Source ID - </strong> {source.name}
                                                                    <>
                                                                        <br/>
                                                                    </>
                                                                </Typography>
                                                            )}
                                                        </Grid>
                                                    </Fragment>
                                                );
                                            })}
                                        </>
                                    </Grid>
                                ) : (
                                    <Alert severity="warning">Matches will appear!</Alert>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        style={{margin: '10px 0'}}
                        justifyContent={"center"}>
                        <Box style={{marginRight: '10px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={submitLoading || !matches.length}
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                {submitLoading ? (
                                    <CircularProgress color="inherit"/>
                                ) : (
                                    <>
                                        Save Values
                                    </>
                                )}
                            </Button>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Modal>
    );
};

export default TrafficSourceIdListModal;
